import React from "react";
import Signin from "./components/Signin";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthContextProvider, UserAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Facilities from "./components/Facilities";
import Facility from "./components/Facility";
import NavigateUserFacility from "./components/NavigateUserFacility";

function LoginProtection({ children }) {
  const { user } = UserAuth();

  if (user) return <Navigate to="/account" />;

  return children;
}

function App() {
  React.useEffect(() => {
    const scheduleNextRefresh = () => {
      const now = new Date();
      const nextRefresh = new Date();
      nextRefresh.setHours(4, 0, 0, 0); // 4:00 AM

      if (now.getTime() >= nextRefresh.getTime()) {
        nextRefresh.setDate(nextRefresh.getDate() + 1);
      }

      const delay = nextRefresh.getTime() - now.getTime();
      console.log(`[AutoRefresh] Programado para las 04:00 AM. Faltan ${Math.round(delay / 60000)} minutos.`);

      const timerId = setTimeout(() => {
        console.log("[AutoRefresh] Recargando aplicación...");
        window.location.reload(true);
      }, delay);

      return timerId;
    };

    const timerId = scheduleNextRefresh();
    return () => clearTimeout(timerId);
  }, []);

  return (
    <div>
      <ThemeProvider>
        <AuthContextProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <LoginProtection>
                  <Signin />
                </LoginProtection>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <NavigateUserFacility>
                    <Navigate to="/facilities" replace />
                  </NavigateUserFacility>
                </ProtectedRoute>
              }
            />
            <Route
              path="/facilities"
              element={
                <ProtectedRoute>
                  <Facilities />
                </ProtectedRoute>
              }
            />
            <Route
              path="/facilities/:id"
              element={
                <ProtectedRoute>
                  <Facility />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthContextProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
